import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: 30px;
  height: 47px;
`;
Container.displayName = 'Container';

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 12px;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Logo = styled.img``;
Logo.displayName = 'Logo';

export const LogoContainer = styled.div`
  align-items: center;
  background-color: #162cf8;
  display: flex;
  height: 56px;
  justify-content: center;
  width: 56px;
`;
LogoContainer.displayName = 'LogoContainer';

export const Points = styled.div`
  color: #ffffff;
  font-size: 48px;
  font-style: normal;
  font-weight: normal;
  line-height: 56px;
  min-width: 70px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  color: #d0fb0c;
  display: flex;
  font-weight: bold;
  justify-content: center;
  min-width: 160px;
  padding: 0 8px;
  text-align: center;
`;
PointsContainer.displayName = 'PointsContainer';

export const Space = styled.div`
  background: #2919a6;
  height: 33px;
  margin: 0 3px;
  width: 1px;
`;
Space.displayName = 'Space';

export const TeamContainer = styled.div`
  align-items: center;
  background: linear-gradient(
    to right,
    #2000c7 0%,
    #0e005f 40%,
    #0e005f 60%,
    #2000c7 100%
  );
  display: flex;
  height: 56px;
  overflow: hidden;
  z-index: 1;
`;
TeamContainer.displayName = 'TeamContainer';

export const TeamName = styled.div`
  color: #ffffff;
  font-size: 43px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.1em;
  line-height: 56px;
  min-width: 124px;
  padding: 0 16px;
  position: relative;
  text-align: center;
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  color: #0a1853;
  flex: 1;
  font-size: 48px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.03em;
  line-height: 56px;
  text-align: center;
`;
Timer.displayName = 'Timer';

export const TimerContainer = styled.div`
  align-items: center;
  background-color: #fffffe;
  display: flex;
  height: 56px;
  justify-content: center;
  margin-right: 8px;
  min-width: 232px;
`;
TimerContainer.displayName = 'TimerContainer';
